import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=0c6cddf2&scoped=true"
import script from "./SnackBar.vue?vue&type=script&lang=ts"
export * from "./SnackBar.vue?vue&type=script&lang=ts"
import style0 from "./SnackBar.vue?vue&type=style&index=0&id=0c6cddf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6cddf2",
  null
  
)

export default component.exports